import { render, staticRenderFns } from "./deals-list.vue?vue&type=template&id=6a0655f2"
import script from "./deals-list.vue?vue&type=script&lang=js"
export * from "./deals-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports